import React from 'react';
import { IMG_URL } from '../../config/apiURL';
import NumberFormat from 'react-number-format';
import Button from '../button';
import Modal from '../modal';

const ProductModal = props => {
   const { product, onClose, onAddProduct } = props;

   return (
      <Modal onClose={onClose}>
         <div className="product-modal-image">
            <a>
               <img
                  src={`${IMG_URL}/catalogo/obtenerimagenes?id_producto=${product.id_producto}`}
                  alt="product cover"
               />
            </a>
         </div>
         <div className="product-modal-information">
            <div className="column">
               <h1 className="product-modal-name quicksand">
                  {product.Producto}
               </h1>
               <h3 className="quicksand product-modal-price">
                  <NumberFormat
                     decimalScale={2}
                     displayType="text"
                     fixedDecimalScale={true}
                     prefix="$"
                     value={product.Precio}
                     thousandSeparator={true}
                  />
               </h3>

               <p>{product.descripcion || product.Producto}</p>

               {/*product.fabricante && (
                  <div className="column product-modal-text-container">
                     <p>Fabricante</p>
                     <div className="product-modal-text">
                        <i className="fas fa-industry" />
                        <p>{product.fabricante}</p>
                     </div>
                  </div>
               )}
               {product.marca && (
                  <div className="column product-modal-text-container">
                     <p>Marca</p>
                     <div className="product-modal-text">
                        <i className="fas fa-tag" />
                        <p>{product.marca}</p>
                     </div>
                  </div>
               )*/}
            </div>

            <Button
               className="product-modal-button"
               onClick={() => {
                  onAddProduct();
                  onClose();
               }}
            >
               Agregar al carrito
            </Button>
         </div>
      </Modal>
   );
};

export default ProductModal;



// WEBPACK FOOTER //
// ./src/components/Products/product-modal.js